import { render, staticRenderFns } from "./QuotationProportional.vue?vue&type=template&id=2c14fc68&scoped=true&"
import script from "./QuotationProportional.vue?vue&type=script&lang=js&"
export * from "./QuotationProportional.vue?vue&type=script&lang=js&"
import style0 from "./QuotationProportional.vue?vue&type=style&index=0&id=2c14fc68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14fc68",
  null
  
)

export default component.exports